import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'w-full sm:w-125 sm:pt-30',
    title: 'sm:heading-3xl heading-2xl',
    description: 'heading-m mt-3',
    button: 'mt-8 w-full sm:mt-10'
  }
});
